export const statusesStyleDictionary: Map<number, string> = new Map([
    [-7, 'rgb(214, 172, 56)'],
    [-12, 'rgb(128, 199, 86)'],
    [-9, 'red'],
    [-8, 'green'],
    [-6, 'red'],
    [-5, 'red'],
    [-4, 'green'],
    [-3, 'rgb(210, 213, 51)'],
    [-2, 'rgb(22, 123, 207)'],
    [-1, 'rgb(156, 155, 155)'],
]);

export const statusGroupesStyleDictionary: Map<number, string> = new Map([
    [1, 'rgb(156, 155, 155)'],
    [2, 'rgb(128, 199, 86)'],
    [3, 'rgb(210, 213, 51)'],
    [4, 'red'],
]);